var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29.2",
    style: {
      enableBackground: "new 0 0 29 29.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3209_",
    transform: "translate(-261.728 -353.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3216_",
    style: {
      fill: "#005AAA"
    },
    d: "M263.5,358.3c-0.1,0.1-0.2,0.3-0.3,0.4c-1.2,1.4-1.7,3.3-1.3,5 c2,10.1,10.4,17.7,20.6,18.6c0.2,0,0.4,0,0.7,0c1.1,0,2.2-0.3,3.2-0.8c0.4-0.2,0.8-0.6,1.1-0.9l0.9-1c1.7-1.9,1.6-4.8-0.3-6.5 l-1.5-1.3c-0.9-0.8-2-1.2-3.1-1.2c-1.3,0-2.5,0.6-3.4,1.5l-0.9,1c-0.3,0.4-0.6,0.8-0.8,1.3c-3.5-1.5-6.4-4.1-8.1-7.4 c0.6-0.3,1.2-0.7,1.7-1.2l0.9-1c1.7-1.9,1.6-4.8-0.3-6.5l-1.5-1.3c-1.9-1.7-4.8-1.6-6.5,0.3L263.5,358.3z M265.2,358.1 c0.7-0.7,1.6-1.1,2.5-1.1c0.9,0,1.7,0.3,2.3,0.9l1.5,1.3c0.7,0.6,1.1,1.5,1.1,2.4c0,0.9-0.3,1.8-0.9,2.5l-0.9,1l0,0 c-0.4,0.5-1,0.8-1.6,1l-0.3,0.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.2-0.1,0.3,0,0.5l0.1,0.3c1.9,3.9,5.2,6.9,9.3,8.5l0.2,0.1 c0.1,0.1,0.3,0.1,0.5,0c0.1-0.1,0.3-0.2,0.3-0.4l0.1-0.2c0.2-0.4,0.4-0.9,0.7-1.2l0.9-1c0.7-0.7,1.6-1.1,2.5-1.1 c0.9,0,1.7,0.3,2.3,0.9l1.5,1.3c1.4,1.3,1.5,3.4,0.2,4.9l-0.9,1c-0.2,0.3-0.5,0.5-0.9,0.7c-0.9,0.5-2,0.8-3.1,0.6 c-9.7-0.9-17.7-8.1-19.5-17.7c-0.4-1.4,0-2.9,0.9-4c0,0,0,0,0.1-0.1l0,0c0,0,0,0,0-0.1c0.1-0.1,0.2-0.2,0.3-0.3L265.2,358.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3213_",
    style: {
      fill: "#005AAA"
    },
    d: "M290.1,367.3c-0.3,0-0.6-0.3-0.6-0.6v0c0-6.7-5.5-12.2-12.2-12.2 c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6c7.5,0,13.5,6,13.5,13.5C290.7,367,290.4,367.3,290.1,367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3210_",
    style: {
      fill: "#005AAA"
    },
    d: "M285.5,367.5c-0.3,0-0.6-0.3-0.6-0.6v0c0-4.3-3.5-7.8-7.8-7.8 c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0,0,0,0,0,0c5,0,9.1,4.1,9.1,9.1C286.1,367.2,285.8,367.4,285.5,367.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.17388d4a89ac2dcd4b86aa119bbca0cf.svg";
export { ForwardRef as ReactComponent };